<template>
  <div>
    <div class="quick_match_add">
      <el-steps :active="active" align-center>
        <el-step title="Type & Invoice#"></el-step>
        <el-step title="Address"></el-step>
        <el-step title="Driver"></el-step>
      </el-steps>
      <div v-show="active == 0">
        <el-form ref="form_one" :model="form_one" :rules="forms_one" label-width="100px" class="demo-ruleForm" label-position="top" :status-icon="true" :show-message="false">

          <div  class="topTask">
            <el-form-item label="Task Type">
              <el-radio-group v-model="form_one.taskType" @input="changeTopTaskType">
                <el-radio :label="1">
                  <div style="display: inline-block">
                    <div class="third"  style="background-color: #1472FF;padding-right: 0">
                      <div style="padding-left: 4px">Pickup</div>
                      <div class="change">Hub</div>
                    </div>
                  </div>
                </el-radio>
                <el-radio :label="2">
                  <div style="display: inline-block">
                    <div class="third">
                      <div class="pickup">Pickup</div>
                      <div>dropoff</div>
                    </div>
                  </div>
                </el-radio>
                <el-radio :label="0">
                  <div style="display: inline-block">
                    <div class="third">
                      <div class="hub">Hub</div>
                      <div>dropoff</div>
                    </div>
                  </div>
                </el-radio>

              </el-radio-group>
            </el-form-item>
          </div>
          <div class="topTask">
            <el-form-item label="Set Urgency">
              <el-radio-group v-model="form_one.set_urgency">
                <el-radio :label="0">Normal</el-radio>
                <el-radio :label="1">High</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="topTask">
            <el-form-item label="Proof requirements">
              <el-checkbox-group v-model="form_one.checkList">
                <el-checkbox :label="1">Photo of delivery</el-checkbox>
                <el-checkbox :label="2">Customer signature</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <el-form-item label="Invoice#" prop="invoice#">
            <el-input v-model="form_one['invoice#']" placeholder="Invoice#"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="active == 1">
        <div class="top_invoice" v-if="form_one.taskType != 2">{{type_invoice}}</div>
        <div class="top_invoice" v-else>
          <span :class="active_type_three == 0?'':'out_boack'" @click="changeTaskType(0)">{{type_invoice}}</span>  |
          <span :class="active_type_three == 1?'':'out_boack'" @click="changeTaskType(1)">{{type_invoiceD}}</span>
        </div>
        <el-form ref="address_form" :model="address_form"  label-width="100px"  class="demo-ruleForm" label-position="top"  :status-icon="true" :show-message="false">
          <el-form-item label="Customer Code" >
            <el-input v-model="address_form.code" placeholder="Customer Code" @blur="getNewAddress()"></el-input>
          </el-form-item>
          <el-form-item label="Contact Details" required>
            <!--              <el-input v-model="input" placeholder="Contact Details"></el-input>-->
            <contact-input ref="contact1"></contact-input>
          </el-form-item>
          <el-form-item label="Destination" required>
            <compose-input ref="compose1"></compose-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="active == 2">
        <el-form ref="form" :model="address_form" label-width="100px"  class="demo-ruleForm" label-position="top">
          <el-form-item label="Driver" >
            <el-select v-model="value" placeholder="select">
              <el-option
                v-for="item in options"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
<!--      <el-button style="margin-top: 12px;" @click="next">下一步</el-button>-->
    </div>
    <div class="footers">
      <div></div>
      <div>
        <button class="handle_button"  ref="myButton" @click="cancelAdd">
          <span v-if="active == 0">Cancel</span>
          <span v-else>Back</span>
        </button>
        <el-button  @click="confirmAdd" class="changeCreate">
          <span v-if="active != 2">Next</span>
          <span v-else>Skip</span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import composeInput from "@/components/composeInput";
import contactInput from "@/components/contactInput";
import {firstAddNewQiickHandle, secondAddNewQiickHandle, thirdAddNewQiickHandle} from "@/api/quick_add_new";
import {getAllProvice, getCodeAddress, getDriverList} from "@/api/tasks";
import listenScan from "@/listenScanCode/listenScan";
export default {
  name: "quick_match_add_newp",
  components:{
    composeInput,contactInput,
    // VueGoogleAutocomplete
  },
  data(){
    return{
      active_type_three:0,
      active:0,
      form_one:{
        taskType:1,
        set_urgency:0 ,
        checkList:[1],
        'invoice#':''
      },
      address_form:{
        code:'',
      },
      value:'',
      options:[],
      type_invoice:'',
      type_invoiceD:'',
      save_address:{},
      forms_one:{
        'invoice#': [
          { required: true, message: 'hhhhhhhhhhh', trigger: 'blur' }
        ],
      },
      save_address_p:{},
      save_address_d:{}
    }
  },
  created() {
    getDriverList({token:localStorage.getItem('token')}).then(res=>{
      this.options = res.data
    })
  },
  methods:{
    changeTopTaskType(){
      this.address_form.code = ''
      this.active_type_three = 0
      this.save_address_p ={}
      this.save_address_d = {}
      this.validateclearForm()
    },
    validateFormOne() {
      let flag = false
      this.$refs['form_one'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    confirmAdd() {
      listenScan.barCode = ''
      if (this.active == 0){
        this.$refs.form_one.validate(valid => {
          if (valid) {
            // this.active++
            this.fistStep(this.form_one["invoice#"],2)
              // if (this.active++ > 2) this.active = 0;
          } else {
            // console.log(this.form_one, 'hello world')
              this.$message({
                type:"warning",
                message:'Some information missing'
              })
          }
        })
      }else if (this.active == 1){
        if  (this.form_one.taskType == 2){
          if (this.active_type_three == 0){
            if (!this.save_address_p.address){
              this.$message({
                type:"warning",
                message:'Some information missing'
              })
            }else {
              this.active_type_three = 1
              this.taskTypeHandle()
            }
          }else {
            if  (!this.save_address_d.address || !this.save_address_p.address){
              this.$message({
                type:"warning",
                message:'Some information missing'
              })
          }else {
              this.active++
            }
          }
        }else {
          let third =this.$refs.contact1.validateForm()
          let fouth =this.$refs.compose1.validateForm()
          if (!third || !fouth){
            this.$message({
              type:"warning",
              message:'Some information missing'
            })
          }else {
            // if (this.active++ > 2) this.active = 0;
            this.active++
          }
        }

      }else if (this.active == 2){
        this.thirdStep(this.value)
      }
      // let contact1 = this.$refs.contact1.form
      // let compose1 = this.$refs.compose1.changeForm
    },
    fistStep(barCode,type){
      firstAddNewQiickHandle({
        data:barCode,
        type:type,
        task_type:this.form_one.taskType,
      }).then(res=>{
        if (res.code  == 200){
          this.form_one["invoice#"] = res.data["invoice#"]
          // let type = this.form_one.taskType == 0?'-P':'-D'
          if (this.form_one.taskType !=2){
            this.type_invoice = '#'+res.data['invoice#']+ '/'+res.data.suffix
          }else {
            this.type_invoice = '#'+res.data['invoice#'] + '-P' + '/'+res.data.suffix
            this.type_invoiceD = '#'+res.data['invoice#'] + '-D' + '/'+res.data.suffix
          }
          this.active = 1
        }else {
          this.$message({
            type:"warning",
            message:res.msg
          })
        }
      })
    },
    scanQuickAdd(barCode){
      if (this.active == 0){
        if (this.form_one.taskType == 0){
         this.fistStep(barCode,1)
          setTimeout(()=>{
            this.scanQuickAdd(barCode)
          },300)
        }else {
          this.fistStep(barCode,1)
        }
      }else if (this.active == 1){
        secondAddNewQiickHandle({
          data:"^b"+barCode,
          type:1
        }).then(res=>{
          if (res.code == 200){
            if (this.form_one.taskType !=2){
              this.save_address = res.data
              for (let key of Object.keys(this.$refs.contact1.form)){
                this.$refs.contact1.form[key] = res.data[key]
              }
              for (let key of Object.keys(this.$refs.compose1.changeForm)){
                this.$refs.compose1.changeForm[key] = res.data[key]
              }
              this.address_form.code = res.data.code
              this.active++
            }else {
              if (this.active_type_three == 0){
                //关联任务得 pickup
               this.save_address_p = res.data
              }else {
                //关联任务得 dropoff
                this.save_address_d = res.data
              }
              for (let key of Object.keys(this.$refs.contact1.form)){
                this.$refs.contact1.form[key] = res.data[key]
              }
              for (let key of Object.keys(this.$refs.compose1.changeForm)){
                this.$refs.compose1.changeForm[key] = res.data[key]
              }
              this.address_form.code = res.data.code
              if (!this.save_address_d.address || !this.save_address_p.address){
                if (this.active_type_three == 0){
                  this.active_type_three =1
                }else {
                  this.active_type_three = 0
                }
                this.address_form.code = ''
                for (let key of Object.keys(this.$refs.contact1.form)){
                  this.$refs.contact1.form[key] = ''
                }
                for (let key of Object.keys(this.$refs.compose1.changeForm)){
                  this.$refs.compose1.changeForm[key] = ''
                }
              }else {
                this.active++
              }
            }
          }else {
            this.$message({
              type:'warning',
              message:res.msg
            })
          }
        })
      }else if (this.active == 2){
        this.thirdStep(barCode)
      }
    },
    thirdStep(barCode){
      let form = {}
      if (this.form_one.taskType == 0){
        //dropoff
        let contact1 = this.save_address
        let third = this.form_one
        form.dropoff = Object.assign(contact1,third)
        form.dropoff.is_signature = this.form_one.checkList.includes('2')?1:0
        form.dropoff.is_photo =this.form_one.checkList.includes('1')?1:0
        form.dropoff.is_notes = 0
        form.dropoff.notes = ''
        form.dropoff.sub_organization_id = this.$store.state.store
        form.dropoff.is_pickup = 0
        form.dropoff.auto_assign = '0'
        form.dropoff.schedule_type = 1
        form.dropoff.worker_code = barCode
        form.dropoff.phone_code = 1
      }else if (this.form_one.taskType == 1){
        let contact1 = this.save_address
        let third = this.form_one
        form.pickup = Object.assign(contact1,third)
        form.pickup.is_signature = this.form_one.checkList.includes('2')?1:0
        form.pickup.is_photo =this.form_one.checkList.includes('1')?1:0
        form.pickup.is_notes = 0
        form.pickup.notes = ''
        form.pickup.sub_organization_id = this.$store.state.store
        form.pickup.is_pickup = 1
        form.pickup.auto_assign = '0'
        form.pickup.schedule_type = 1
        form.pickup.worker_code = barCode
        form.pickup.phone_code = 1
      }else if (this.form_one.taskType == 2) {
        let contact = this.save_address_d
        let thirds = this.form_one
        form.dropoff = Object.assign(contact,thirds)
        form.dropoff.is_signature = this.form_one.checkList.includes('2')?1:0
        form.dropoff.is_photo =this.form_one.checkList.includes('1')?1:0
        form.dropoff.is_notes = 0
        form.dropoff.notes = ''
        form.dropoff.sub_organization_id = this.$store.state.store
        form.dropoff.is_pickup = 0
        form.dropoff.auto_assign = '0'
        form.dropoff.schedule_type = 1
        form.dropoff.worker_code = barCode
        form.dropoff.phone_code = 1

        let contact1 = this.save_address_p
        let third = this.form_one
        form.pickup = Object.assign(contact1,third)
        form.pickup.is_signature = this.form_one.checkList.includes('2')?1:0
        form.pickup.is_photo =this.form_one.checkList.includes('1')?1:0
        form.pickup.is_notes = 0
        form.pickup.notes = ''
        form.pickup.sub_organization_id = this.$store.state.store
        form.pickup.is_pickup = 1
        form.pickup.auto_assign = '0'
        form.pickup.schedule_type = 1
        form.pickup.worker_code = barCode
        form.pickup.phone_code = 1
      }
      thirdAddNewQiickHandle(form).then(res=>{
        if (res.code == 200){
          this.$emit('closeDialog')
          this.active = 0
          this.form_one["invoice#"] = ''
          this.address_form.code = ''
          this.value = ''
          this.form_one.taskType = 1
          this.active_type_three = 0
          this.save_address_p ={}
          this.save_address_d = {}
         this.validateclearForm()
          this.$message({
            type:"success",
            message:res.msg
          })
        }else {
          this.$message({
            type:"warning",
            message:res.msg
          })
        }
      })
    },
    getNewAddress(){
      let code = this.address_form.code
      getCodeAddress({
        code:code,
        sub_organization_id : this.$store.state.store
        }).then(res=>{
          if (res.code == 200){
              // this.$refs.compose1.changeForm = res.data
              // this.$refs.contact1.form = res.data
            if (this.form_one.taskType != 2){
              this.save_address = res.data
              this.save_address.code = code
            }else {
              if (this.active_type_three == 0){
                //关联任务得 pickup
                this.save_address_p = res.data
                this.save_address_p.code = code
              }else {
                //关联任务得 dropoff
                this.save_address_d = res.data
                this.save_address_d.code = code
              }
            }
            for (let key of Object.keys(this.$refs.contact1.form)){
              this.$refs.contact1.form[key] = res.data[key]
            }
            for (let key of Object.keys(this.$refs.compose1.changeForm)){
              this.$refs.compose1.changeForm[key] = res.data[key]
            }
            this.$refs.contact1.form.phone_code = 1
          }else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
    },
    changeTaskType(a){
      this.active_type_three = a
      this.$refs.contact1.validateClear()
      this.$refs.compose1.validateClear()
      this.taskTypeHandle()
    },
    taskTypeHandle(){
      if (this.active_type_three == 0){
        //关联任务得 pickup
        this.address_form.code = this.save_address_p.code
        for (let key of Object.keys(this.$refs.contact1.form)){
          this.$refs.contact1.form[key] = this.save_address_p[key]
        }
        for (let key of Object.keys(this.$refs.compose1.changeForm)){
          this.$refs.compose1.changeForm[key] = this.save_address_p[key]
        }
      }else {
        //关联任务得 dropoff
        this.address_form.code = this.save_address_d.code
        for (let key of Object.keys(this.$refs.contact1.form)){
          this.$refs.contact1.form[key] = this.save_address_d[key]
        }
        for (let key of Object.keys(this.$refs.compose1.changeForm)){
          this.$refs.compose1.changeForm[key] = this.save_address_d[key]
        }
      }
      this.$refs.contact1.form.phone_code = 1
    },
    cancelAdd(){
          listenScan.barCode = ''
          if (this.active == 0){
            this.$emit('closeDialog')
            this.active = 0
            this.form_one["invoice#"] = ''
            this.address_form.code = ''
            this.value = ''
            this.form_one.taskType = 1
            this.active_type_three = 0
            this.save_address_p ={}
            this.save_address_d = {}
            this.validateclearForm()
            // this.forms.resetFields()
          }else {
            setTimeout(()=>{
              if (this.active == 1){
                if  (this.form_one.taskType == 2){
                  this.taskTypeHandle()
                  if (this.active_type_three == 1){
                    this.active_type_three = 0
                    //关联任务得 pickup
                    this.address_form.code = this.save_address_p.code
                    for (let key of Object.keys(this.$refs.contact1.form)){
                      this.$refs.contact1.form[key] = this.save_address_p[key]
                    }
                    for (let key of Object.keys(this.$refs.compose1.changeForm)){
                      this.$refs.compose1.changeForm[key] = this.save_address_p[key]
                    }
                  }else {
                    this.active--
                  }
                }else {
                  this.active--
                  this.address_form.phone_code =1
                  for (let key of Object.keys(this.$refs.contact1.form)){
                    this.$refs.contact1.form[key] = this.save_address[key]
                  }
                  for (let key of Object.keys(this.$refs.compose1.changeForm)){
                    this.$refs.compose1.changeForm[key] = this.save_address[key]
                  }
                }

              }else {
                this.active--
              }
            },100)
          }
          this.$refs.myButton.blur();
    },
    validateclearForm(){
      this.$nextTick(() => {
        if (this.$refs.contact1) {
          this.$refs.contact1.validateClear()
          this.$refs.compose1.validateClear()
        }
      })
      this.$refs.contact1.form={
        phone_code:1,
        phone: "",
        recipient_name: "",
      },
        this.$refs.compose1.changeForm ={
          address:"",
          abs:"",
          city:"",
          province:'ON',
          postcode: '',
          options:[]
        }
    },
  }
}
</script>

<style scoped lang="less">
.quick_match_add{
  //text-align: center;
  max-width: 800px;
  margin: 50px auto;
}
/deep/ .is-process{
   .el-step__icon{
    background-color: #1F2D42!important;
    color: #fff!important;
  }
}
/deep/ .el-step__head.is-finish{
  //color: #1F2D42!important;
  border-color: #1F2D42!important;
  //background-color: #1F2D42!important;
  color: #ffffff !important
}
/deep/ .el-step__title.is-finish{
  color: #1F2D42;
}
/deep/ .el-step__icon{
  width: 40px;
  height: 40px;
  //background-color: #1F2D42;
  //color: #ffffff;
}
/deep/.is-finish .el-step__icon{
    background-color: #1F2D42!important;
}
/deep/ .el-step.is-horizontal .el-step__line{
  top: 19px;
}
.topTask{
  padding-bottom: 16px;
  border-bottom: 1px solid #E0E0E0;
  /deep/ .el-radio{
    font-weight: bold;
  }
  .scedule{
    /deep/.el-radio{
      font-weight: normal;
    }
  }
}
.third{
  display: flex;
  padding-right: 5px;
  color: #FFFFFF;
  height: 18px;
  line-height: 18px;
  margin-top: 8px;
  background-color: #FFC215;
  font-size: 12px;
  border-radius: 4px;
  .hub{
    background-color: #1F2D42;
    border-radius: 4px;
    padding: 0 5px;
    margin-right: 5px;
  }
  .change{
    background-color: #1F2D42;
    border-radius: 4px;
    padding: 0 5px;
    margin-left: 5px;
  }
  .pickup{
    background:#1472FF;
    padding: 0 5px;
    margin-right: 5px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
}

.footers{
  width:calc( 100% - 72px);
  z-index: 1;
  height: 64px;
  background: #1F2D42;
  position: fixed;
  bottom: 0;
  margin-left: -32px;
  line-height: 64px;
  display: flex;
  justify-content: space-between;
  padding-right: 48px;
  padding-left: 32px;
  color: #FFFFFF;
}
.top_invoice{
  font-size: 14px;
  font-family: SFPro-Semibold, SFPro;
  font-weight: 600;
  color: #1F2D42;
  line-height: 20px;
  margin-top: 32px;
}
.out_boack{
  color: #CCCCCC;
  cursor: pointer;
}
.handle_button{
  width: 80px;
  height: 32px;
  border-radius: 16px;
  border: 1px solid #FFFFFF;
  background-color: #1F2D42;
  font-size: 14px;
  font-family: SFPro, SFPro;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 24px;
  margin-right: 16px;
  cursor: pointer;
}
/deep/.el-step__title.is-wait{
  color: #cccccc !important;
}
/deep/.el-step__head.is-wait {
   color: #CCCCCC;
   border-color: #CCCCCC;
 }
/deep/.el-step__line{
  background-color: #CCCCCC;
}
/deep/.is-finish .el-step__line{
 background-color: #1F2D42!important;
}
</style>
